<template>
  <b-form class="al-form" test-id="al-form" @submit.stop.prevent>
    <slot />
    <div class="al-form__footer" :class="{ 'al-form__footer--fixed': fixedFooter }">
      <div>
        <slot name="footer" />
      </div>
    </div>
  </b-form>
</template>

<script>
export default {
  props: {
    fixedFooter: Boolean
  }
};
</script>

<style lang="scss">
.al-form {
  .al-form__divider {
    background: color(white, darken, 2);
    height: 1px;
    margin: 20px 0;
    width: 100%;
  }

  .al-form__footer {
    background: color(white, lighten, 1);
    margin: 0;

    > div {
      border-top: 1px solid color(white, darken, 2);
      padding-bottom: 24px;
      padding-top: 24px;
      text-align: right;
    }

    &--fixed {
      bottom: 0;
      left: 0;
      position: fixed;
      width: 100%;
      z-index: 2;
    }

    .question-form-buttons {
      border-top: 1px solid #d9e3e2;
      margin-top: 48px;
      padding-top: 24px;
      text-align: right;
    }
  }
}
</style>
